export class TypeLieu {
  constructor(
    public readonly id: number | undefined,
    public readonly code: string,
  ) {}
}
